
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { GroupSurveyExtension, GroupSurveyMapping, SurveyView } from '../../../backend/backendapi';
import SurveyStore from '../../../../stores/SurveyStore';
import SelectModal from '../../../selectmodal/selectmodal.controller';
import { emptyUUID } from '../../../../util';
import SurveySelectModal from './SurveySelectModal';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { paginationOptions, searchOptions } from '../../../../util/vue-good-table';
import { TabSlotFunctions } from '../../../group/EditModal/TabSlot';
import { getLocalizedSurveyNameFromSurvey } from '../../utils';

type GroupSurveyMappingWithSurveyName = {
  groupSurveyMapping: GroupSurveyMapping;
  surveyName: string;
}

@Component({
  components: {
    SurveySelectModal,
    VueGoodTable,
  },
})
export default class GroupSurveyMappingEditor extends Vue implements TabSlotFunctions {
  @Prop({ required: true })
  readonly group!: GroupSurveyExtension;

  private readonly surveyStore = new SurveyStore();

  get allSurveysForSelectModal(): SurveyView[] {
    //we only what to show not linked surveys in the select modal
    const alreadyPresentSurveyIds = new Set(this.group.surveyMappings.map(e => e.surveyId));
    return this.surveyStore.surveys.filter(e => !alreadyPresentSurveyIds.has(e.id));
  }

  get columnsConfig(): any[] {
    return [{
      label: this.$t('survey.group.model.groupSurveys.survey').toString(),
      field: (e: GroupSurveyMappingWithSurveyName) => e.surveyName,
    }, {
      label: this.$i18n.t('general.actions').toString(),
      field: 'actions',
      width: '5em',
    }];
  }

  get groupSurveysWithSurveyName(): GroupSurveyMappingWithSurveyName[] {
    return this.group.surveyMappings.map((mapping: GroupSurveyMapping) => ({
      groupSurveyMapping: mapping,
      surveyName: getLocalizedSurveyNameFromSurvey(this.surveyStore.surveysById.get(mapping.surveyId), '?', this.$i18n.locale),
    }));
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  mounted(): void {
    this.surveyStore.loadIfAbsent();
  }

  onRemoveSurvey(mapping: GroupSurveyMappingWithSurveyName): void {
    const index = this.group.surveyMappings.findIndex(e => e.surveyId === mapping.groupSurveyMapping.surveyId);
    if (index >= 0) {
      this.group.surveyMappings.splice(index, 1);
    }
  }

  onSurveysSelected(surveys: SurveyView[]): void {
    this.group.surveyMappings.push(...surveys.map(s => GroupSurveyMapping.fromJS({
      id: emptyUUID(),
      surveyId: s.id,
      groupSurveyExtensionId: this.group.id,
    })));
  }

  openSelectModal(): void {
    (this.$refs.selectModal as SelectModal<SurveyView>).open();
  }
}
